{
  "title": "Inviter un bénévole dans l'équipe {{team}}",
  "titleUnnamed": "Inviter un bénévole",
  "rolesTitle": "Choisir les rôles",
  "continue": "Continuer",
  "invite": "Envoyer l'invitation",
  "inviting": "Envoi de l'invitation",
  "roles": "Rôles",
  "rolesHint": "Facultatif. Les rôles pourront être modifiés plus tard depuis le menu du bénévole.",
  "searchPlaceholder": "Rechercher par prénom ou adresse e-mail",
  "searchLabel": "Rechercher des personnes",
  "noMatches": "Aucune personne ne correspond à cette recherche.",
  "createInstead": "Vous ne trouvez pas la personne que vous cherchez ? Créer une nouvelle personne",
  "searchInstead": "Rechercher plutôt une personne existante",
  "nameLabel": "Nom",
  "namePlaceholder": "Nom complet",
  "emailLabel": "Adresse e-mail",
  "emailPlaceholder": "nom@exemple.com"
}
